<template>
    <scrollMore @scrollState="scrollState">
    <div class="w100 accrual serve-center">
        <div class="w100 accrual-head po-a" :style="{ 'background-image': `url(${baseUrl}images/hcxy-accrualBasis-bg.png)` }">
            <div class="w120 mc font-40 page-name" style="padding-top: 83px;">办事大厅</div>
        </div>

        <div class="w120 accrual-main po-r" >

            <div class="w100 pb20 mt20">
                <div class=" of-h bor-ra" style="width: 100%;"
                v-loading="loading">
                    <div style="border-bottom: 1px solid transparent;
                    margin-bottom: 16px;
                    border-top-right-radius: 5px;
                border-top-left-radius: 5px;" class="bor-ra bg-w">
                        <searhRidoSelect @clickEvent="clickEventFn"/>
                    </div>
                    <div class="bg-w pb20 bor-ra">



                    <div class="cl-f pt20">
                        <div class="fr search-check">
                            <el-checkbox v-model="applyType">可在线办理</el-checkbox>
                        </div>
                        <div class="fr">
                            <div class="table-search">
                                <input type="text" v-model="paramSearch.keywords"
                                       placeholder="请输入服务"
                                       @keyup.enter="getListInput"/>
                                <div class="table-search-btn" @click="getListInput">
                                    <i class="el-icon-search font-18 white" ></i>
                                </div>
                            </div>
                        </div>
                        
                        <div class="fr">
                            <div class="table-search" style="width:200px;display: flex;align-items: center;">
                               <el-radio v-model="viewType" label="1">按列表显示</el-radio>
                                <el-radio v-model="viewType" label="2">按图标显示</el-radio>
                            </div>
                        </div>

                    </div>
                    <div class="pl10 pr10"  v-if="viewType=='1'">
                        <el-table class="w100 mt20 table" header-row-class-name="table-head"
                                  row-class-name="cu-p" stripe :data="list">
                            <el-table-column align="center" label="序号" width="50px">
                                <template slot-scope="scope">
                                    {{scope.$index + 1 }}
                                </template>
                            </el-table-column>
                            <el-table-column align="center" label="服务名称">
                                <template slot-scope="scope">
                                    <div>
                                        <el-image
                                                class="img-warp"
                                                :src="scope.row.fileUrl"
                                                fit="contain">
                                        </el-image>
                                        <div v-text="scope.row.serveName"></div>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" prop="gcRole" label="服务对象">
                                <template slot-scope="scope">
                                    {{ getServeObj(scope.row.roleList,'roleType')}}
                                </template>
                            </el-table-column>
                            <el-table-column align="center" prop="gcSubject" label="服务主题">
                                <template slot-scope="scope">
                                    {{ arrMapToStr(scope.row.subjectList,'subjectName')}}
                                </template>
                            </el-table-column>
                            <el-table-column align="center"  prop="belongDeptName" label="所属部门"></el-table-column>
                            <el-table-column align="center" label="操作" width="240px">
                                <template slot-scope="scope">
                                    <div class="to-use">
                                        <div v-if="scope.row.serveType == '0' " @click="goQuery(scope.row)">
                                            查看
                                        </div>
                                        <div v-else>
                                            <span class="allow" @click="goHref(scope.row.serveId,'/ServeCenterDetail')">办事指南</span>
                                            <span  :class="[(scope.row.applyType==1||scope.row.applyType==3)?'allow':'refused']"
                                                        @click="(scope.row.applyType==1||scope.row.applyType==3)&&HandleApply(scope.row);">线上办理</span>
                                        </div>
                                        <div>
                                            <span class="allow" @click="favorOrRecall(scope.row)">{{scope.row.tagType?'取消收藏':'收藏'}}</span>
                                            <span  class="allow"
                                                   @click="goHref(scope.row.serveId,'/serveEvaluate')">好差评</span>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="no-data" v-if="loading">正在加载更多...</div>
                        <div class="no-data" v-if="!loading&&list.length>=total&&list.length!=0">没有更多数据</div>
                    </div>
                    <div class="pl10 pr10" style="display: flex;width: 100%;flex-wrap: wrap;justify-content: space-between;" v-if="viewType=='2'">
                        <div class="serve-item" v-for="(e, i) in list" :key="i" @click="(e.applyType==1||e.applyType==3)&&HandleApply(e)">
                            <div class="serve-logo">
                                <img :src="e.fileUrl" alt="">
                            </div>
                            <div class="serve-name ellipsis">{{e.serveName}}</div>
                        </div>
                        <div class="no-data" v-if="loading" style="margin: 0 auto;">正在加载更多...</div>
                        <div class="no-data" v-if="!loading&&list.length>=total&&list.length!=0" style="margin: 0 auto;">没有更多数据</div>
                    </div>
                </div>
            </div>
            </div>
        </div>
       <IframeView ref="IframeView"></IframeView>
        <queryTypeModal
          :data="dataModal"
          @close="onDialogClose"/>
    </div>
    </scrollMore>
</template>

<script>

    import { getSubjectVoList,getServeVoList,favorOrRecall} from '@/api/serveCenter/serveCenter';
    import byTextSearch from '@/components/common/byTextSearch/byTextSearch.vue'
    import treeMenu from "@/components/treeMenu/index.vue";
    import IframeView from "@/components/public/IframeView.vue";
    import { bpmnStartProcess} from '@/api/bpmnApi/bpmn';
    import searhRidoSelect from '@/components/common/searhRidoSelect.vue'
    import scrollMore from '@/components/common/scrollMore.vue'
    import queryTypeModal from "@/components/common/queryTypeModal.vue";

    export default {
        name: "ServeCenter",
        components: {
            byTextSearch,
            treeMenu,
            IframeView,
            searhRidoSelect,
            scrollMore,
            queryTypeModal
        },
        props: [],
        data() {
            return {
                baseUrl: process.env.BASE_URL,
                themeName:'',
                active: "theme",
                oScoges: {
                    dom: '.dept-tree',
                    msg: '已经是最后一个！',
                    callback: this.fnVFindCallback
                },
                searchText: "",
                list:[],
                leftLoading:false,
                loading: false,
                paramSearch:{
                    current:1,
                    size:10,
                    keywords:'',
                    apply_type:''
                },
                itemSelectObj:{

                },
                applyType:false,
                total:0,
                dataModal:{
                    show: false,
                    data:{},
                },
                middlePage:"",
                viewType:"1"
            };
        },
        created() {},
        mounted() {
            window.sessionStorage.setItem("processInstId", "");
            if(window.sessionStorage.getItem('setConfig')&&JSON.parse(window.sessionStorage.getItem('setConfig')).middlePage){
                this.middlePage = JSON.parse(window.sessionStorage.getItem('setConfig')).middlePage;
            }
        },
        destroyed() {},
        methods: {
            goQuery(row){
                if(row.serveType == '0' && row.queryType == '2'){
                    this.dataModal.show = true
                    this.dataModal.data = row
               }if(row.serveType == '0' && row.queryType == '1'){
                   this.$refs.IframeView.showView(row.queryPcUrl, row.taskInstId,row.serveName);
               }
            },
            getListInput(){
                this.paramSearch.current=1;
                this.list =[]
                this.getListFn();
            },
            clickEventFn(params){
                this.itemSelectObj=params;
                this.paramSearch.current=1;
                this.list =[]
                this.getListFn();
            },
            // 查询类跳转
            serveTo(url){
               this.$router.push( url)
            },
            HandleApply(item){
                if(!this.middlePage){
                    let processDefId=item.processDefId;
                    bpmnStartProcess({processDefId}).then(({data})=>{
                        if(data.code==0){
                            window.sessionStorage.setItem("processInstId", data.data.processInstId);
                            this.$refs.IframeView.showView(data.data.url, data.data.taskInstId);
                            // window.open(data.data.url);
                        }else{
                            this.$message.warning(data.msg||'流程系统业务忙，请刷新或者重新操作');
                        }

                    }).catch(err=>{
                        this.$message.error("服务异常" );
                    })
                }else {
                    let routeData = this.$router.resolve({
                        path: `/ServeCenterDetail`,
                        query:{id:item.serveId}
                    });
                    window.open(routeData.href);
                }
            },

            favorOrRecall(item){
                const params={
                    isFavor:!item.tagType?true:false,
                    serveId:item.serveId
                }
                this.loading = true;
                favorOrRecall(params).then(({data})=>{
                    this.loading = false;
                    if(data.code == 0){
                        this.$message.success( !item.tagType?"收藏成功!" :"取消收藏成功!");
                        item.tagType=item.tagType?null:true;
                    }else{
                        this.$message.warning(data.msg|| "操作失败!" );
                    }


                }).catch(err=>{
                    this.loading = false;
                })


            },
            goHref(id,path){
                let routeData = this.$router.resolve({
                    name:path,
                    query: {id}
                });
                window.open(routeData.href);
                // this.$router.push({path: name, query:{id}})
            },

            scrollState(flag){
                if(flag){
                    if(this.list.length<this.total){
                        this.paramSearch.current++;
                        this.getListFn();
                    }
                }

            },

            // 获取查询列表
            getListFn () {
                this.loading = true;
                getServeVoList({...this.paramSearch,...this.itemSelectObj}).then(({data})=> {
                    this.loading = false;
                    if(data.code == 0){
                        this.list = this.list.concat(data.data.records || []);
                        this.total = data.data.total;

                    }
                })
                    .catch(() => {
                        this.loading = false;
                    });
            },
            arrMapToStr(arr,k){
                arr=arr||[]
                let list=arr.map(i=>i[k])
                return list.join('、')
            },
            getServeObj(arr,k){
                arr=arr||[];
                let obj={"0":"教职工","1":"学生"}
                let list=arr.map(i=>obj[i[k]+'']);
                  list=[...new Set(list)];
                return list.join("、");
            },
            onDialogClose() {
                this.dataModal.show = false
            },
        },
        watch: {
            applyType(val){
                if(val){
                    this.paramSearch.apply_type='1,3'
                }else {
                    this.paramSearch.apply_type=''
                }
                this.paramSearch.current=1;
                this.list =[]
                this.getListFn();

            }
        },
        filters: {},
    };
</script>

<style scoped lang="less" >
    .accrual{
        background: #F2F3F6;
        &-head {
            height: 602px;
            background: no-repeat center center;
            background-size: cover;
            top: 0;
        }
        &-main {
            margin: 100px auto 0 auto;
            .tab-item {
                width: 300px;
                height: 60px;
                color: #ffffff;
                line-height: 60px;
                text-align: center;
                font-size: 20px;
                background: rgba(255, 255, 255, 0.2);
                cursor: pointer;
                &.active {
                    color: #333333;
                    background: #ffffff;
                }
            }
        }
        .left-nav {
            margin-right: 20px;
            padding: 12px 0;
            width: 214px!important;
            background: #fff;
            margin-left: 10px;
            &-search{
                position: absolute;
                top:0px;
                width: 100%;
            }

            &-link {
                margin: 10px 0;
                position: relative;

                &-inner{
                    height: 50px;
                    font-size: 16px;
                    line-height: 50px;
                    cursor: pointer;
                    width: 200px;
                    left: 21px;
                    border-bottom-left-radius: 50px;
                    border-top-left-radius: 50px;
                    position: relative;
                    &-icon{
                        /*background: #F1F3F4;*/
                        margin-top: 12px;
                        width: 25px;
                        height: 25px;
                        margin-left: 12px;
                        overflow: hidden;
                        &.borderR{
                            border-radius: 13px;
                        }
                        >img{
                            width: 100%;
                            vertical-align: top;
                        }
                    }
                    &-name{
                        width: 110px;
                        text-align: left;
                        padding-left: 10px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        color: #7c7857;

                    }
                    &-count{
                        color: #0B4470;
                    }

                }
                &.active {
                    .left-nav-link-inner{
                        color: #ffffff;
                        background: rgba(73, 164, 240, 1);
                        z-index: 1;
                        &-name{
                            color: #fff;
                        }
                        &-count{
                            color: #fff;
                        }
                    }

                    &:after {
                        content: '';
                        display: block;
                        width: 0;
                        height: 0;
                        border: 8px solid transparent;
                        position: absolute;
                        bottom: -8px;
                        z-index: 0;
                        border-left: 8px solid #3E86A0;
                        right: -15px;
                    }
                }
            }
        }
        .search-check{
            padding-right: 20px;
            padding-top: 11px;
        }
        .table-search{
            width:268px;
            height: 40px;
            position: relative;
            margin-right: 30px;
            input{
                width:210px;
                height: 40px;
                border: none;
                background:#F7F7F7;
                padding-left: 8px;
                outline: none;

            }
            &-btn{
                width:58px;
                height: 40px;
                text-align: center;
                line-height: 45px;
                background: #49A4F0;
                position: absolute;
                cursor: pointer;
                right: 0;
                top: 0;
            }

        }
        .img-warp{
            width: 40px;
            height: 40px;
            cursor: pointer
        }
        .to-use{
            span{
                display: inline-block;
                width: 70px;
                height: 26px;
                line-height: 26px;
                margin: 3px 3px;
                font-size: 14px;
                background: #F1F2F4;
                &.allow:hover{
                    color: white!important;
                }
                &.refused{
                    cursor:not-allowed;
                    color: #ccc;
                }
            }

        }
    }
    .left-st{
        max-height: 600px;
        overflow: auto;
    }
    /deep/.el-input--suffix{
        input{
            border: none;
            background: #F7F7F7;
            border-radius: 0px;
        }
    }
    // /deep/.el-table {
    //     th{
    //         background: #E8F2FA!important;
    //         border-top: 1px solid #4D8ABA;
    //         border-bottom: 1px solid #4D8ABA;
    //     }
    // }
.serve-item {
    width: 160px;
    height: 150px;
    background: #f2f2f2;
    margin: 14px;
    padding-top: 15px;
    user-select: none;
    border-radius: 8px;
    cursor: pointer;
    .serve-logo {
        text-align: center;
        padding-top: 10px;
        >img {
            height: 60px;
            width: 60px;
            border-radius: 0;
        }
    }
    .serve-name {
        text-align: center;
        font-size: 18px;
        line-height: 46px;
    }
    .rateClass{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .itemTypeCla{
        position: relative;
        width: 80px;
        padding: 5px 0;
        text-align: center;
        background: #29bb9c;
        color: #fff;
    }
    .itemTypeCla:before {
        display:block;
        content:'';
        border-width:12px 8px 12px 8px;
        border-style:solid;
        border-color:#29bb9c transparent transparent transparent;
        /* 定位 */
        position:absolute;
        left:90%;
        top:0;
    }
    .itemTypeCla:after {
        display:block;
        content:'';
        border-width:12px 8px 12px 8px;
        border-style:solid;
        border-color:transparent transparent #29bb9c transparent;
        /* 定位 */
        position:absolute;
        left:90%;
        top:10%;
    }
}
</style>

